import * as v from "valibot";

import { rpcContract } from "../rpc";

const broadcasterSnapshotSchema = v.object({
  session_id: v.string(),
  stream_id: v.string(),
  timestamp: v.number(),
  video_bitrate_sent: v.number(),
  frames_encoded: v.number(),
  frames_sent: v.number(),
  frames_per_second: v.number(),
  frame_width: v.number(),
  frame_height: v.number(),
  packets_sent: v.number(),
  retransmitted_packets_sent: v.number(),
  nack_count: v.number(),
  current_rtt: v.number(),
  available_outgoing_bitrate: v.optional(v.number()),
  audio_bitrate_sent: v.optional(v.number()),
  audio_packets_sent: v.optional(v.number()),
  remote_packets_lost: v.optional(v.number()),
  remote_jitter: v.optional(v.number()),
  remote_fraction_lost: v.optional(v.number()),
  quality_limitation_reason: v.optional(v.string()),
  target_bitrate: v.optional(v.number()),
  encoder_implementation: v.optional(v.string()),
  ice_connection_state: v.optional(v.string()),
  video_codec: v.optional(v.string()),
  audio_codec: v.optional(v.string()),
  quality_score: v.optional(v.number()),
  operating_system: v.optional(v.string()),
  browser: v.optional(v.string()),
  browser_version: v.optional(v.string()),
  device_type: v.optional(v.string()),
  device_name: v.optional(v.string()),
});

export const ingestBroadcasterTelemetryRpcContract = rpcContract({
  name: "ingest-broadcaster-telemetry" as const,
  paramsSchema: v.object({
    snapshots: v.array(broadcasterSnapshotSchema),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    inserted: v.number(),
  }),
});

export type IngestBroadcasterTelemetryParams = v.InferOutput<
  (typeof ingestBroadcasterTelemetryRpcContract)["paramsSchema"]
>;
export type IngestBroadcasterTelemetryResult = v.InferOutput<
  (typeof ingestBroadcasterTelemetryRpcContract)["resultSchema"]
>;
